import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "f40bc28b-2599-4799-b767-b02c9decb3b7",
  body: [principle01, principle02, task01],
  publicId: "4",
  name: "Masking effects",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
};

export default lesson;
